export const QUINE_APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION;

export const USERNAME_REGEX = /^[a-z\d](?:[a-z\d]|-(?=[a-z\d])){0,38}$/i;

// For @username
export const USER_MENTION_REGEX = /\B@[a-z\d](?:[a-z\d]|-(?=[a-z\d])){0,38}/i;

// https://stackoverflow.com/a/41543705
export const EMOJI_REGEX =
  /[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2580-\u27BF]|\uD83E[\uDD10-\uDDFF]/g;
